import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./RiskSlider.scss";

const RiskSlider = () => {
  return (
    <div className="risk-slider">
      <h3>This Week</h3>
      <Carousel indicators={false}>
        <Carousel.Item>
          <div className="risk-slider__content">
            <span className="task">Identify and analyze risks</span>
            <div className="date">
              <h5>Due date:</h5>
              <span>23 Apr 2023</span>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="risk-slider__content">
            <span className="task">Identify and analyze risks</span>
            
            <div className="date">
              <h5>Due date:</h5>
              <span>23 Apr 2023</span>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default RiskSlider;
